import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus-fill",
  "use": "icon-plus-fill-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-plus-fill\">\n<path id=\"icon-plus-fill_形状结合\" d=\"M10,0.5c5.2,0,9.5,4.3,9.5,9.5s-4.2,9.5-9.5,9.5S0.5,15.2,0.5,10S4.8,0.5,10,0.5z M10,5.7\n\tC9.6,5.7,9.3,6,9.3,6.4l0,0l0,2.9l-2.8,0C6,9.3,5.7,9.6,5.7,10s0.3,0.7,0.7,0.7l0,0l2.8,0l0,2.9c0,0.4,0.3,0.7,0.7,0.7\n\ts0.7-0.3,0.7-0.7l0,0l0-2.9l2.8,0c0.4,0,0.7-0.3,0.7-0.7S14,9.3,13.6,9.3l0,0l-2.8,0l0-2.9C10.7,6,10.4,5.7,10,5.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol